(() => {
  let loading = false;

  document.addEventListener('click', async (event) => {
    const button = event.target.closest('[data-tis-load-more-button]');
    if (!button || loading) return;

    const root = button.closest('[data-tis-load-more]');
    const grid = document.getElementById('product-grid');
    const count = root?.querySelector('[data-tis-load-more-count]');
    const status = root?.querySelector('[data-tis-load-more-status]');
    const nextUrl = button.dataset.nextUrl;
    const sectionId = root?.dataset.sectionId;
    if (!root || !grid || !nextUrl || !sectionId) return;

    loading = true;
    button.disabled = true;
    button.textContent = 'Loading';

    try {
      const requestUrl = new URL(nextUrl, window.location.origin);
      requestUrl.searchParams.set('section_id', sectionId);
      const response = await fetch(requestUrl, { headers: { Accept: 'text/html' } });
      if (!response.ok) throw new Error(`Unable to load products (${response.status})`);

      const documentFragment = new DOMParser().parseFromString(await response.text(), 'text/html');
      const nextGrid = documentFragment.getElementById('product-grid');
      const nextRoot = documentFragment.querySelector('[data-tis-load-more]');
      const nextButton = nextRoot?.querySelector('[data-tis-load-more-button]');
      const nextCount = nextRoot?.querySelector('[data-tis-load-more-count]');
      const products = [...(nextGrid?.children || [])];
      if (!products.length) throw new Error('No additional products were returned');

      products.forEach((product) => grid.append(document.importNode(product, true)));
      if (count && nextCount) count.textContent = nextCount.textContent.trim();

      const visibleCollectionTotal = document
        .querySelector('.tis-catalog-toolbar__title sup')
        ?.textContent.trim();
      if (count && /^\d+$/.test(visibleCollectionTotal || '')) {
        count.textContent = `${grid.children.length} of ${visibleCollectionTotal} products`;
      }

      if (nextButton?.dataset.nextUrl) {
        button.dataset.nextUrl = nextButton.dataset.nextUrl;
        button.disabled = false;
        button.textContent = 'Load More';
      } else {
        button.remove();
      }

      if (status) status.textContent = `${products.length} more products loaded. ${count?.textContent || ''}`;
    } catch (error) {
      button.disabled = false;
      button.textContent = 'Try Again';
      if (status) status.textContent = 'Products could not be loaded. Please try again.';
    } finally {
      loading = false;
    }
  });
})();
